import {configureStore} from '@reduxjs/toolkit'
import UserReducer from "./features/userSlice"
import AuthReducer from "./features/Auth"

export const store = configureStore({
    reducer:{
        user : UserReducer,
        auth : AuthReducer
    }
})

export type RootState = ReturnType<typeof store.getState>

export type AppDispatch = typeof store.dispatch